angular.module('impactx.confirmation').controller('DenyWarningCtrl', [
    '$scope',
    '$mdDialog',
    'trns',
    'referencingProducts',
    'themeFactory',
    'TranslationService',
    DenyWarningCtrl]);

function DenyWarningCtrl($scope, $mdDialog, trns, referencingProducts, themeFactory, TranslationService)
{
    $scope.trns = trns;
    $scope.saveLabel = TranslationService.get("ok");
    $scope.abortLabel = TranslationService.get("abort");
    $scope.referencingProducts = referencingProducts;
    $scope.theme = themeFactory.getTheme();

    this.cancel = function ()
    {
        $mdDialog.cancel();
    };
    this.answer = function ()
    {
        $mdDialog.hide();
    };
}